import { render } from "./HomeDigdaya.vue?vue&type=template&id=5b76631c"
import script from "./HomeDigdaya.vue?vue&type=script&lang=js"
export * from "./HomeDigdaya.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__